export const DB_CONFIG_URL: string = '/api/App/ListSettings?lang=en-gb';
